import { render, staticRenderFns } from "./AcceleratorCompany.vue?vue&type=template&id=425d2cdf&scoped=true"
import script from "./AcceleratorCompany.vue?vue&type=script&lang=js"
export * from "./AcceleratorCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425d2cdf",
  null
  
)

export default component.exports